import enGB from "./en-GB.json";
import frFR from "./fr-FR.json";

const localeMap = {
  "en-GB": enGB,
  "fr-FR": frFR,
};

const translations = {
  getTranslations(locale) {
    return localeMap[locale] || localeMap["en-GB"]; // Default to english
  },
};

export default translations;
